import AvailabilityInfo from "@/pages/medewerkers/$userId/beschikbaarheid/AvailabilityInfo"
import { createFileRoute, useParams } from "@tanstack/react-router"
import { checkPermissions } from "@/utils/checkPermissions"

export const Route = createFileRoute(
  "/beheer/medewerkers/$userId/beschikbaarheid/",
)({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "employees"),
})

function RouteComponent() {
  const { userId } = useParams({ from: "/beheer/medewerkers/$userId" })

  return <AvailabilityInfo userId={Number(userId)} pageType="user_detail" />
}
